// Utilities
import { createPinia } from 'pinia'
import { createSentryPiniaPlugin } from "@sentry/vue";

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin({
  stateTransformer: (state: any) => {
    if (state.topSecret.doNotSend) {
      // Return null to not send this version of the state.
      return null;
    }
    // Transform the state to remove sensitive information
    const transformedState = {
      ...state,
      topSecret: {
        ...state.topSecret,
        // Replace sensitive information with something else
        nuclearLaunchCodes: "I love pizza",
        // or just remove it entirely
        hiddenTreasureLocation: null,
      },
      // You should also remove large data that is irrelevant to debugging to not clutter your Sentry issues
      giganticState: null,
    };
    return transformedState;
  },
}));

export default pinia